import * as THREE from "three";
import { Vector3 } from "three";
import { useRef, useEffect } from "react";
import { useControls, Leva } from "leva";
import { Perf } from "r3f-perf";
import { useFrame } from "@react-three/fiber";
import { useHelper } from "@react-three/drei";
import useGame from './stores/useGame.js'

export default function Lights({ vec = new Vector3(), ...props }) {
  // const {camera} = useThree(state)

  // Zustand
  // const showEscape = useGame((state)=>{state.showEscape})
  const showDoorMessage = useGame((state) => {return state.showEscape})

  const {
    sLight,
    Base_Pos,
    Base_color,
    Base_Rot,
    Door_Pos,
    Door_color,
    Door_Rot,
    Door_Att,
    Door_Penum,
    Door_Intens,
    Player_color,
    Player_Y_Pos,
    Player_Att,
    Player_Penum,
    Player_Intens,
    spotLight3_Pos,
    spotLight3_color,
    spotLight3_Rot,
    Floor_color,
    Floor_intensity,
    Floor_pos,
    portalLight0_Pos,
  } = useControls({

    // portal light
    portalLight0_Pos: {
      value: { x: 131, y: -122, z: 108 },
      step: 1,
    },

    // basement light
    Base_Pos: {
      value: { x: 248, y: -149, z: 163 },
      step: 1,
    },
    Base_color: "#a8ff86",
    Base_Rot: {
      value: { x: -240, y: -124, z: -2888 },
      step: 1,
    },


    spotLight1_Pos: {
      value: { x: 166, y: -16, z: 86 },
      step: 1,
    },

    Player_Y_Pos: 18,
    Player_color: "#a1b5ff",
    spotLight1_Rot: {
      value: { x: -240, y: -124, z: -2888 },
      step: 1,
    },

    //door light
    Door_Pos: {
      value: { x: 154, y: -14, z: 120 },
      step: 1,
    },
    Door_color: "#b10000",
    Door_Rot: {
      value: { x: -276, y: 67, z: -20000 },
      step: 1,
    },

    Door_Penum: 0.9,
    Door_Intens: 1040,
    Door_Att: 5,

    Player_Att: 5,
    Player_Penum: 0.4,
    Player_Intens: 7000,

    // Floor_color: "#eb264d",
    Floor_color: "#000000",
    Floor_intensity: 1.5,
    Floor_pos:{
      value: { x: 153, y: -9, z: 81 },
      step: 1,
    },

    spotLight3_Pos: {
      value: { x: 148, y: -12, z: 0 },
      step: 1,
    },
    spotLight3_color: "#a8ff86",
    spotLight3_Rot: {
      value: { x: 0, y: 0, z: 0 },
      step: 1,
    },
  });

  const portalLight0 = useRef();
  const portalLight = useRef();
  const portalLight2 = useRef();
  const portalLight3 = useRef();

  const directionalLight = useRef();
  const spotLight1 = useRef();
  const Door = useRef();
  // useHelper(directionalLight, THREE.DirectionalLightHelper, 1);
  // useHelper(spotLight1, THREE.SpotLightHelper);
  // useHelper(spotLight1, THREE.DirectionalLightHelper);
  // useHelper(Door, THREE.SpotLightHelper, 1);
  // useHelper(portalLight0, THREE.SpotLightHelper, 1);

  useEffect(() => {
    Door.current.target.position.set(0, -15, -290);
    Door.current.target.updateMatrixWorld();
  }, []);

  useEffect(() => {
    if(showDoorMessage) {
      spotLight1.current.intensity = 0;
      console.log('spotlight 1 intensity should be 0')
    }
  }, [showDoorMessage]);

  useFrame((state) => {

    // Player_Y_Pos = state.camera.position.y +10

    // player light follows until door
    if (state.camera.position.x <= 110) {
      spotLight1.current.position.set(
        state.camera.position.x,
        // 18,
        Player_Y_Pos,
        state.camera.position.z
      );
      spotLight1.current.target.position.set(
        state.camera.position.x,
        state.camera.position.y,
        state.camera.position.z
      );
      spotLight1.current.target.updateMatrixWorld();
    }

  });



  // basement lights target position
  useEffect(() => {
    portalLight0.current.target.position.set(131, -300, 108);
    portalLight.current.target.position.set(131, -300, 108);
    portalLight2.current.target.position.set(131, -300, 108);
    // portalLight3.current.target.position.set(131, -300, 108);
    portalLight0.current.target.updateMatrixWorld();
    portalLight.current.target.updateMatrixWorld();
    portalLight2.current.target.updateMatrixWorld();
    // portalLight3.current.target.updateMatrixWorld();
  }, []);
  

  return (
    <>
      {/* <Perf position="top-left" /> */}
      <Leva hidden={true} />
      <spotLight
          ref={portalLight0}
          position={[portalLight0_Pos.x,portalLight0_Pos.y,portalLight0_Pos.z]}
          color={Door_color}
          intensity={4000}
          attenuation={5}
          penumbra={0.9}
          // target-position={[152, -88, 134]}
          />

      <spotLight
          ref={portalLight}
          position={[portalLight0_Pos.x,portalLight0_Pos.y + 64,portalLight0_Pos.z]}
          color={Door_color}
          intensity={4000}
          attenuation={5}
          penumbra={0.9}
          />

<spotLight
          ref={portalLight2}
          position={[portalLight0_Pos.x,portalLight0_Pos.y - 64,portalLight0_Pos.z]}
          color={Door_color}
          intensity={4000}
          attenuation={5}
          penumbra={0.9}
          />

{/* <spotLight
          ref={portalLight3}
          position={[portalLight0_Pos.x,portalLight0_Pos.y + 128,portalLight0_Pos.z]}
          color={Door_color}
          intensity={Door_Intens}
          attenuation={5}
          penumbra={0.9}
          /> */}

          

      

      {/* // PlayerLight */}
{      <spotLight
        ref={spotLight1}
        attenuation={Player_Att}
        penumbra={Player_Penum}
        // distance={1600}

        // Scheele's Green
        // color={"#478800"}
        color={Player_color}
        // position={ [ 10, Player_Y_Pos, 10 ] }
        intensity={Player_Intens}
      />}

{/* {      <directionalLight
        ref={spotLight1}
        attenuation={Player_Att}
        penumbra={Player_Penum}
        // distance={1600}

        // Scheele's Green
        // color={"#478800"}
        color={Player_color}
        position={ [ 10, Player_Y_Pos, 10 ] }
        intensity={Player_Intens}
      />} */}



      {/* // DoorLight */}
      <spotLight
        ref={Door}
        attenuation={Door_Att}
        penumbra={Door_Penum}
        // distance={1600}
        color={Door_color}
        position={[Door_Pos.x, Door_Pos.y, Door_Pos.z]}
        target-position={[Door_Rot.x, Door_Rot.y, Door_Rot.z]}
        intensity={Door_Intens}
      />

      <directionalLight
        ref={directionalLight}
        color={Floor_color}
        position={[0, 636, -101]}
        intensity={Floor_intensity}
      />

      <ambientLight intensity={1} />
    </>
  );
}
